import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

// Define a type for the slice state
export interface SystemState {
  theme: string;
}

// Define the initial state using that type
const initialState: SystemState = {
  theme: "light",
};

export const systemSlice = createSlice({
  name: "system",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    changeTheme(
      state,
      action: PayloadAction<{
        theme: string | 'light';
      }>
    ) {
      state.theme = action.payload.theme;
    },
  },
});

export const { changeTheme } = systemSlice.actions;

// Other code such as selectors can use the imported `RootState` type

export const getSystemState = (state: RootState) => state.system;

export default systemSlice.reducer;
